/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-floating-promises */
import React, { useEffect, useState } from 'react';
import { Formik } from 'formik';
import { toast } from 'react-toastify';

import {
  Container,
  ContainerText,
  ButtonContainer,
  InputError,
  Text,
  ContainerForm,
  Titulo,
  ContentForm,
  ContentFormTwo,
  Space,
} from './styles';
import { ValidationCampos } from '../../../Validation';
import { InputPassword } from '../../atoms/InputPassword';
import { Button } from '../../atoms/Button';
import { Errors } from './errors';

import Main from '../../atoms/Main';
import { useApiStrategyContext } from '../../../context/api-strategy-context';

interface IContent {
  id: string;
}

interface Values {
  senhaNova: string;
  senhaNovaConfirmar: string;
}

const Content = ({ id }: IContent): JSX.Element => {
  const [loading, setLoading] = useState(false);
  const { api } = useApiStrategyContext();

  useEffect(() => {
    const validateToken = async (): Promise<void> => {
      const response = await api.validateToken();
      if (response.status === 403) {
        GoPasswordError();
      }
    };

    validateToken();
  }, []);

  const GoLogin = (): void => {
    window.location.replace('/redefinicao-senha/voltar');
  };

  const GoPasswordError = (): void => {
    window.location.replace('/');
  };

  const validate = (values: Values): void => {
    const errors: any = {};

    const validationNovaSenha = ValidationCampos(values.senhaNova);

    if (values.senhaNova.length === 0) {
      errors.senhaNova = 'Campo Obrigatório';
    } else if (!validationNovaSenha.minCaracteres) {
      errors.senhaNova = 'Pelo menos 8 caracteres';
    } else if (!validationNovaSenha.especialCaracteres) {
      errors.senhaNova = 'Contém caractere especial (@#$&*)';
    } else if (!validationNovaSenha.maiusculas) {
      errors.senhaNova = 'Contém letra maiúscula (A-Z)';
    } else if (!validationNovaSenha.minusculas) {
      errors.senhaNova = 'Contém letra minúscula (a-z)';
    } else if (!validationNovaSenha.numeros) {
      errors.senhaNova = 'Contém número (0-9)';
    } else if (!validationNovaSenha.passwordRegexPattern) {
      errors.senhaNova = 'Senha inválida!';
    }

    if (values.senhaNovaConfirmar.length === 0) {
      errors.senhaNovaConfirmar = 'Campo Obrigatório';
    } else if (values.senhaNovaConfirmar !== values.senhaNova) {
      errors.senhaNovaConfirmar = 'A senhas devem ser iguais';
    }

    return errors;
  };

  const handleSubmit = async ({
    values,
    onSubmitProps,
  }: any): Promise<void> => {
    try {
      setLoading(true);
      const response = await api.editPassword({
        id,
        password: values.senhaNova,
        passwordConfirmation: values.senhaNovaConfirmar,
      });

      if (response.status === 200) {
        setLoading(false);
        setTimeout(GoLogin, 300);
        onSubmitProps.resetForm();
      }
    } catch (error) {
      toast.warning('Token expirado, faça uma nova solicitação');
      setTimeout(GoPasswordError, 2000);
    }
  };

  return (
    <Main>
      <ContainerText>
        <Text>REDEFINIÇÃO DE SENHA</Text>
      </ContainerText>
      <Container>
        <Formik
          validateOnMount={true}
          validate={validate}
          initialValues={{
            senhaNova: '',
            senhaNovaConfirmar: '',
          }}
          onSubmit={async (values, onSubmitProps) => {
            await handleSubmit({ values, onSubmitProps });
          }}
        >
          {({ errors, values, touched, handleChange }) => (
            <ContainerForm>
              <ContentForm>
                <Titulo>Redefinir nova senha:</Titulo>
                <InputPassword
                  name="senhaNova"
                  placeholder="Nova senha"
                  onChange={handleChange}
                  touched={touched.senhaNova}
                  value={values.senhaNova}
                  error={errors.senhaNova}
                  isErrorMessage={errors.senhaNova}
                >
                  {touched.senhaNova &&
                    errors.senhaNova === 'Campo Obrigatório' && (
                      <InputError>{errors.senhaNova}</InputError>
                    )}
                </InputPassword>
                <Space>
                  <InputPassword
                    name="senhaNovaConfirmar"
                    placeholder="Confirmar nova senha"
                    isErrorMessage={errors.senhaNovaConfirmar}
                    onChange={handleChange}
                    touched={touched.senhaNovaConfirmar}
                    value={values.senhaNovaConfirmar}
                    error={errors.senhaNovaConfirmar}
                  >
                    {touched.senhaNovaConfirmar &&
                      errors.senhaNovaConfirmar && (
                        <InputError>{errors.senhaNovaConfirmar}</InputError>
                      )}
                  </InputPassword>
                </Space>
              </ContentForm>

              <ContentFormTwo>
                <Errors values={errors.senhaNova} errors={values.senhaNova} />
                <ButtonContainer>
                  <Button name="Redefinir senha" loading={loading} />
                </ButtonContainer>
              </ContentFormTwo>
            </ContainerForm>
          )}
        </Formik>
      </Container>
    </Main>
  );
};

export default Content;
